import { Resource as CommonResource } from '@pflegia/types/common/enums/resource.enum';

export enum Resource {
  Activity = 'Activity',
  Admin = 'Admin',
  Benefit = 'Benefit',
  Booster = 'Booster',
  Candidate = CommonResource.Candidate,
  CandidateComment = CommonResource.CandidateComment,
  CandidateFile = CommonResource.CandidateFile,
  CareerCoachCallRequest = 'CareerCoachCallRequest',
  CemStatistics = 'CemStatistics',
  Chat = 'Chat',
  /**
   * Workaround for react-admin as resource should have same name as entity.
   */
  ChatThread = 'ChatThread',
  CommonKeywords = 'CommonKeywords',
  ContractType = CommonResource.ContractType,
  Department = 'Department',
  DocumentationSystem = 'DocumentationSystem',
  EducationHistory = 'EducationHistory',
  EmailHistory = CommonResource.EmailHistory,
  Employer = CommonResource.Employer,
  EmployerDocument = 'EmployerDocument',
  EmployerChecklist = 'EmployerChecklist',
  EmployerChecklistQuestion = 'EmployerChecklistQuestion',
  EmployerComment = 'EmployerComment',
  EmployerInterviewLocation = CommonResource.EmployerInterviewLocation,
  EmployerInterviewTimeSlot = 'EmployerInterviewTimeSlot',
  EmployerQuestionnaire = 'EmployerQuestionnaire',
  EmployerStatistics = 'EmployerStatistics',
  FailedPushFlowItem = 'FailedPushFlowItem',
  Interview = CommonResource.Interview,
  InterviewReminder = 'InterviewReminder',
  InvalidCandidate = 'InvalidCandidate',
  Invite = 'Invite',
  InviteStatistics = 'InviteStatistics',
  JobPosition = CommonResource.JobPosition,
  JobPositionPitch = 'JobPositionPitch',
  JobPositionTemplate = 'JobPositionTemplate',
  JobTitle = CommonResource.JobTitle,
  JobTitlePageContent = 'JobTitlePageContent',
  KamPush = 'KamPush',
  Match = CommonResource.Match,
  MatchChecklist = 'MatchChecklist',
  MatchComment = CommonResource.MatchComment,
  MatchEmployerChecklist = 'MatchEmployerChecklist',
  MatchesContactPerson = 'MatchesContactPerson',
  MatchInterviewDates = 'MatchInterviewDates',
  NewsletterEdition = 'NewsletterEdition',
  NewsletterEditionJobTitleArticle = 'NewsletterEditionJobTitleArticle',
  NewsletterWeeklyStatistic = 'NewsletterWeeklyStatistic',
  Organisation = 'Organisation',
  OrganisationContactPerson = 'OrganisationContactPerson',
  OvertimeCompensation = CommonResource.OvertimeCompensation,
  Permission = CommonResource.Permission,
  PflegiaEmployee = 'PflegiaEmployee',
  PflegiaEmployeeCallLog = 'PflegiaEmployeeCallLog',
  PflegiaEmployeeClick = 'PflegiaEmployeeClick',
  PflegiaForFriends = 'PflegiaForFriends',
  Playbook = 'Playbook',
  PushPlan = 'PushPlan',
  Qualification = 'Qualification',
  Role = CommonResource.Role,
  SalaryNegotiation = 'SalaryNegotiation',
  ScheduledInvite = CommonResource.ScheduledInvite,
  SeoLandingPage = 'SeoLandingPage',
  SeoPageMeta = 'SeoPageMeta',
  SipgateCall = 'SipgateCall',
  SipgateCallInsightReview = 'SipgateCallInsightReview',
  SmsSetting = 'SmsSetting',
  Specialty = 'Specialty',
  Statistic = 'Statistic',
  Team = CommonResource.Team,
  Template = CommonResource.Template,
  TrainingHistory = 'TrainingHistory',
  WhatsAppMessage = CommonResource.WhatsAppMessage,
  WhatsAppConsole = 'WhatsAppConsole',
  WorkHistory = CommonResource.WorkHistory,
}
